import * as R from "ramda";
import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { MenuItemLink, getResources, WithPermissions } from "react-admin";
import { withRouter } from "react-router-dom";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import ListIcon from "@material-ui/icons/List";
import Schedule from "@material-ui/icons/Schedule";
import SettingsIcon from "@material-ui/icons/Settings";
import PageView from "@material-ui/icons/Pageview";
import Lock from "@material-ui/icons/Lock";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";

import SubMenu from "./SubMenu";
import { getPermissions, isSuperUser } from "../redux/user/selectors";

const mapStateToProps = (state) => ({
  resources: getResources(state),
  open: getSidebarStatus(state),
  permissions: getPermissions(state),
  isSuperUser: isSuperUser(state),
});

const getSidebarStatus = (state) => state.admin.ui.sidebarOpen;

function getTitle(resource) {
  const title = R.pathOr(resource.name, ["options", "label"], resource);
  return `${title[0].toUpperCase()}${title.slice(1)}`;
}

function getResourceByName(resources, name) {
  return R.find(R.propEq("name", name))(resources);
}

function getIcon(resource) {
  if (resource.icon) {
    const IconComponent = resource.icon;
    return <IconComponent />;
  }

  return <ListIcon />;
}

function checkPermissions(permissions, permissionLists) {
  if (!permissions || !permissionLists) return false;
  const results = permissionLists.map((currentPermission) => {
    const [entity, currentRight] = currentPermission.split(".");
    const result = permissions
      .filter((elm) => elm.entity === entity)
      .filter((elm) => elm.perm === currentRight && elm.status === true);

    return result.length >= 1;
  });
  return results.some((elm) => elm === true);
}

class Menu extends React.Component {
  state = {
    menuTransfer: false,
    menuImages: false,
    menuAudit: false,
    menuSessions: false,
    menuStations: false,
  };

  handleToggle = (menu) => {
    this.setState((state) => ({ [menu]: !state[menu] }));
  };

  render() {
    const {
      onMenuClick,
      open,
      resources,
      permissions,
      isSuperUser,
    } = this.props;
    const doctorResource = getResourceByName(resources, "doctors");
    const clinicResource = getResourceByName(resources, "clinics");
    const patientResource = getResourceByName(resources, "patients");
    // const patientResource = resources[1];
    const staffResource = getResourceByName(resources, "staff");
    return (
      <div>
        {checkPermissions(permissions, ["doctors.view"]) ? (
          <MenuItemLink
            to={`/${doctorResource.name}`}
            primaryText={getTitle(doctorResource)}
            leftIcon={getIcon(doctorResource)}
            onClick={onMenuClick}
          />
        ) : null}
        {checkPermissions(permissions, ["doctors.view"]) ? (
          <MenuItemLink
            to={`/${clinicResource.name}`}
            primaryText={getTitle(clinicResource)}
            leftIcon={getIcon(clinicResource)}
            onClick={onMenuClick}
          />
        ) : null}
        {checkPermissions(permissions, [
          "patients.view",
          "patients.view cpi data",
        ]) ? (
          <MenuItemLink
            to={`/${patientResource.name}`}
            primaryText={getTitle(patientResource)}
            leftIcon={getIcon(patientResource)}
            onClick={onMenuClick}
          />
        ) : null}
        {isSuperUser && (
          <MenuItemLink
            to={`/${staffResource.name}`}
            primaryText={getTitle(staffResource)}
            leftIcon={getIcon(staffResource)}
            onClick={onMenuClick}
          />
        )}
        <SubMenu
          handleToggle={() => this.handleToggle("menuStations")}
          isOpen={this.state.menuStations}
          sidebarIsOpen={open}
          icon={<DeveloperBoardIcon />}
          name="Stations"
        >
          {resources
            .filter(
              (resource) =>
                R.pathOr(null, ["options", "root"], resource) === "stations"
            )
            .map((resource, key) => {
              const label = R.pathOr(null, ["options", "label"], resource);
              if (!label) {
                return null;
              }
              return (
                <MenuItemLink
                  to={`/${resource.name}`}
                  primaryText={getTitle(resource)}
                  leftIcon={getIcon(resource)}
                  onClick={onMenuClick}
                  key={key}
                />
              );
            })}
        </SubMenu>

        <SubMenu
          handleToggle={() => this.handleToggle("menuSessions")}
          isOpen={this.state.menuSessions}
          sidebarIsOpen={open}
          icon={<Schedule />}
          name="Sessions"
        >
          {resources
            .filter(
              (resource) =>
                R.pathOr(null, ["options", "root"], resource) === "sessions"
            )
            .map((resource, key) => {
              const label = R.pathOr(null, ["options", "label"], resource);
              if (!label) {
                return null;
              }
              return (
                <MenuItemLink
                  to={`/${resource.name}`}
                  primaryText={getTitle(resource)}
                  leftIcon={getIcon(resource)}
                  onClick={onMenuClick}
                  key={key}
                />
              );
            })}
        </SubMenu>
        <SubMenu
          handleToggle={() => this.handleToggle("menuAudit")}
          isOpen={this.state.menuAudit}
          sidebarIsOpen={open}
          icon={<Lock />}
          name="Audit"
        >
          {resources
            .filter(
              (resource) =>
                R.pathOr(null, ["options", "root"], resource) === "audit"
            )
            .map((resource, key) => {
              const label = R.pathOr(null, ["options", "label"], resource);
              if (!label) {
                return null;
              }
              return (
                <MenuItemLink
                  to={`/${resource.name}`}
                  primaryText={getTitle(resource)}
                  leftIcon={getIcon(resource)}
                  onClick={onMenuClick}
                  key={key}
                />
              );
            })}
        </SubMenu>
        <SubMenu
          handleToggle={() => this.handleToggle("menuTransfer")}
          isOpen={this.state.menuTransfer}
          sidebarIsOpen={open}
          icon={<GroupAddIcon />}
          name="Transfers"
        >
          {resources
            .filter(
              (resource) =>
                R.pathOr(null, ["options", "root"], resource) === "transfer"
            )
            .map((resource, key) => {
              const label = R.pathOr(null, ["options", "label"], resource);
              if (!label) {
                return null;
              }
              return (
                <MenuItemLink
                  to={`/${resource.name}`}
                  primaryText={getTitle(resource)}
                  leftIcon={getIcon(resource)}
                  onClick={onMenuClick}
                  key={key}
                />
              );
            })}
        </SubMenu>
        {isSuperUser && (
          <SubMenu
            handleToggle={() => this.handleToggle("menuImages")}
            isOpen={this.state.menuImages}
            sidebarIsOpen={open}
            icon={<PageView />}
            name="Images"
          >
            {resources
              .filter(
                (resource) =>
                  R.pathOr(null, ["options", "root"], resource) === "images"
              )
              .map((resource, key) => {
                const label = R.pathOr(null, ["options", "label"], resource);
                if (!label) {
                  return null;
                }
                return (
                  <MenuItemLink
                    to={`/${resource.name}`}
                    primaryText={getTitle(resource)}
                    leftIcon={getIcon(resource)}
                    onClick={onMenuClick}
                    key={key}
                  />
                );
              })}
          </SubMenu>
        )}
        <MenuItemLink
          to="/app_settings"
          primaryText="App settings"
          leftIcon={<SettingsIcon />}
          onClick={onMenuClick}
        />
      </div>
    );
  }
}

const enhace = compose(withRouter, connect(mapStateToProps));

export default enhace(Menu);
